// extracted by mini-css-extract-plugin
export default {"carouselp":"carousel_carouselp__4MyoF"};